module.exports = __webpack_public_path__ + "imgs/gazprom.f48ac938.webp";